module.exports = __webpack_public_path__ + "img/stripe.2cc7d94d.svg";